import { formatDateTime } from '@pickleballinc/lib/format-dates';
import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';

import { PICKLEBALL_PLACEHOLDER_IMAGE } from '@/utils/helpers/constants';

interface ArticleCardProps {
  imageUrl: string;
  title: string;
  description?: string;
  type?: 'paginationContain' | 'paginationCover' | 'latest' | 'popular';
  publishedAt?: string;
  alt?: string;
  authorFullName: string;
}

export const PictureArticleCard = ({
  imageUrl,
  title,
  description,
  type = 'paginationCover',
  publishedAt,
  alt,
  authorFullName,
}: ArticleCardProps) => {
  const typeStyles = {
    paginationContain: '!w-full',
    paginationCover: '!w-full',
    latest: '!w-full',
    popular: '!w-full',
  };

  return (
    <div
      className={`flex size-full cursor-pointer flex-row rounded-xl border border-gray-200 bg-white text-gray-900 shadow-md sm:shadow-transparent ${typeStyles[type]}`}
    >
      <img
        src={`${getCDNURL(imageUrl || PICKLEBALL_PLACEHOLDER_IMAGE, 1000, 1000)}`}
        alt={alt ? alt : title}
        className={`w-1/2 rounded-l-xl object-cover`}
      />

      <div className='flex flex-col gap-3 px-3 py-2 rounded-r-xl w-1/2 justify-between'>
        <div className='flex flex-col gap-1'>
          <p className='text-xs font-medium sm:text-sm text-brand-700'>Photo</p>
          <h3 className='text-sm sm:text-lg text-gray-900 font-semibold !line-clamp-4'>{title}</h3>
          {description ? (
            <p className='text-base text-gray-500 hidden sm:block'>{description}</p>
          ) : null}
        </div>
        <div className='flex flex-row justify-between items-center'>
          <div className='flex flex-row gap-3'>
            <div className='flex gap-1'>
              {/* TODO: Add author image when it arrives in payload
                 <Avatar size="sm" /> 
                */}
              <div className='flex flex-col justify-between gap-1'>
                <div
                  className='relative text-xs font-medium leading-none text-gray-900'
                  itemScope
                  itemProp='author'
                  itemType='https://schema.org/Person'
                >
                  <span itemProp='name'>{authorFullName}</span>
                </div>
                {type === 'paginationCover' && publishedAt ? (
                  <p className='text-gray-500 text-xs'>
                    {formatDateTime(publishedAt, { localTimezone: true })}
                  </p>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
